import { Component } from '@angular/core';

@Component({
  selector: 'app-cpr-table-screen',
  templateUrl: './cpr-table-screen.component.html',
  styleUrls: ['./cpr-table-screen.component.scss'],
})
export class CprTableScreenComponent {}
